import { log } from './log';

const pagePathPatterns = ['/shopping/basket'];

export const isPageMarkedForCacheCleanup = () => {
  const isCleanupPage = pagePathPatterns.some((item) => window.location.pathname.includes(item));
  if (isCleanupPage) {
    log('Cache cleanup is always requested for current page.');
  }

  return isCleanupPage;
};
